import styled from "styled-components";
import { theme } from "../../../config";

export const Main = styled.div`
  ${theme.mainContainerStyle}

  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  @media ${theme.breakpoints.mobileAndTablet} {
    ${theme.hideScrollbar}
  }
`;

export const Logo = styled.img`
  position: fixed;
  width: 164px;
  height: auto;
  left: 44px;
  top: 44px;

  @media ${theme.breakpoints.mobileAndTablet} {
    position: absolute;
    top: 25px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    width: 145px;
  }
`;

export const Container = styled.div`
  margin-top: 50px;
  width: 620px;

  .ant-form-item-label > label {
    display: none;
  }

  .ant-form input[type="file"] {
    display: none;
  }

  @media ${theme.breakpoints.mobileAndTablet} {
    margin-top: 80px;
    width: 100%;
  }

  input,
  textarea,
  .ant-select-selection-item {
    font-size: 14px;
  }
`;

export const Title = styled.p`
  font-family: Orkney Medium;
  font-size: 34px;
  font-weight: 700;
  line-height: 48px;
  text-align: center;

  @media ${theme.breakpoints.mobileAndTablet} {
    font-size: 21.6px;
    line-height: 26px;
  }
`;

export const CheckboxWrapper = styled.div`
  text-align: center;
  margin: 0 10%;
  margin-top: 40px;

  @media ${theme.breakpoints.mobileAndTablet} {
    margin-top: 30px;
    text-align: left;
  }
`;

export const ModalHyperlink = styled.span`
  cursor: pointer;
  color: ${theme.colors.activeAnchor};
`;
